export const shortenArray = (arr: any[], allowUpto: number = 3) => {
  if (arr?.length <= allowUpto) return arr;
  else return [...arr?.slice(0, 3), `& ${arr?.length - allowUpto} more`];
};
